export default "__VITE_PUBLIC_ASSET__a5e5d6a3__"